import { getPreferredTranslation } from 'src/_helpers/getPreferredTranslation'

// Numer celu („Cel 3”) siedzi w podtytule tłumaczenia - ten sam, który pokazują kafelki listy celów.
export function getSustainableDevelopmentGoalTitle(goal, locale) {
  const translation = getPreferredTranslation(goal, locale) || {}
  const title = translation?.title || goal?.title || ''
  const number = translation?.subtitle?.trim()

  return number && title ? `${number} – ${title}` : title
}

export function joinSustainableDevelopmentGoalTitles(goals, locale) {
  return Array.isArray(goals)
    ? goals
        .map((goal) => getSustainableDevelopmentGoalTitle(goal, locale))
        .filter(Boolean)
        .join(', ')
    : ''
}
